import styled from 'styled-components'

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`

export const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to bottom, white 95%, rgba(255, 255, 255, 0));
  z-index: 2;
`
